import { render } from "./configure-vehicle-component.vue?vue&type=template&id=77222218"
import script from "./configure-vehicle-component.vue?vue&type=script&lang=js"
export * from "./configure-vehicle-component.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__